// @flow

import 'babel-polyfill';
import 'utils/polyfill.js';
import React                            from 'react';
import ReactDOM                         from 'react-dom';
import App                              from './containers/app';
import { unregister }                   from './registerServiceWorker';
import store                            from './store';
import { BrowserRouter }                from 'react-router-dom';
import { Provider }                     from 'react-redux';
import { setLanguages, addTranslation } from 'react-localize-redux';
import TagManager from 'react-gtm-module'

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

// === URL
window.URL_BASE     = process.env.REACT_APP_BASE_URL;
window.URL_API_BASE = process.env.REACT_APP_API_BASE_URL;
window.URL_API_URL  = process.env.REACT_APP_API_URL;

// === GLOBAL variables
window.S3BUCKET     = process.env.REACT_APP_S3BUCKET;
window.CUSTOMERGURU = process.env.REACT_APP_CUSTOMERGURU;


const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
}

TagManager.initialize(tagManagerArgs);

// === LANGUAGES INIT
const languages = ['en', 'dk'];
store.dispatch(setLanguages(languages, 'dk'));
const locales = [
  'common', 'session', 'navigation', 'main/applications', 'main/companybranding', 'faq/faq',
  'main/insurance_inquiry', 'main/calculator', 'settings/index', 'main/special_deals', 'main/reminder'
];
locales.forEach(function(locale) {
  store.dispatch(addTranslation(require("./locale/" + locale + ".locale.json")));
});

ReactDOM.render(
  <Provider store={store} >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js